import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addApproverLabel: {
		id: 'software-releases-approvers.approver-selector.add-approver-label',
		defaultMessage: 'Add approver',
		description: 'The title of the approvers card',
	},
	findUserLabel: {
		id: 'software-releases-approvers.approver-selector.find-user-label',
		defaultMessage: 'Find user',
		description: 'The placeholder for the user select popup',
	},
	genericErrorFlagTitle: {
		id: 'software-releases-approvers.approver-selector.generic-error-flag-title',
		defaultMessage: "We couldn't add the version approver.",
		description: 'The title of the flag that is displayed when adding version approver fails.',
	},
	genericErrorFlagDescription: {
		id: 'software-releases-approvers.approver-selector.generic-error-flag-description',
		defaultMessage:
			'Something went wrong. Please try again or contact your administrator if the problem persists.',
		description:
			'The description of the flag that is displayed when adding version approver fails.',
	},
});
